import {
  GENERIC_MODAL_CANCEL_BUTTON,
  GENERIC_MODAL_IMPORT_BUTTON,
} from '@commons/Modals/GenericModal/genericModalActions';

import ImportExcelFileModal from '@backoffice/components/ImportExcelFileModal';

export const IMPORT_MODAL_STEPS = {
  // Common import modal steps
  SELECT_FILE: 'select-file',
  VALIDATE_FILE: 'validate-file',
  VALIDATED_FILE: 'validated-file',
  ERROR_FILE: 'error-file',
  // Ingredients import modal steps
  PARTIALLY_VALIDATED_FILE: 'partially-validated-file',
  // Supplier products import modal steps
  WARNING: 'warning',
};

export const getValidationFileConfig = ({
  updatedFile,
  handleFileChange,
  handleFileValidation,
  title,
  subTitle,
}) => ({
  width: '542px',
  height: 'auto',
  type: 'action',
  title,
  icon: '/images/inpulse/file-upload-black-small.svg',
  data: {
    subTitle,
    selectedFile: updatedFile,
    setSelectedFile: handleFileChange,
  },
  component: ImportExcelFileModal,
  actions: [
    {
      ...GENERIC_MODAL_CANCEL_BUTTON(),
      handleClick: () => handleFileChange(null),
    },
    {
      ...GENERIC_MODAL_IMPORT_BUTTON(),
      handleClick: () => handleFileValidation(updatedFile),
    },
  ],
});
